/**
 * Global store reset helper.
 * Call on logout to clear ALL session/persisted app state that is user- or artist-specific.
 */

import { clearArtistSessionCaches } from "@/stores/clearArtistSessionCaches";
import { useContactDetailsStore } from "@/stores/contactDetailsStore";
import { useInstagramStore } from "@/stores/instagramStore";
import { useNotificationStore } from "@/stores/notificationStore";
import { useBookingStore } from "@/stores/bookingStore";
import { useSubscriptionStore } from "@/stores/subscriptionStore";
import { useVideoStore } from "@/stores/videoStore";
import { useAssistantStore } from "@/stores/assistantStore";
import { useUserStore } from "@/stores/userStore";
import { useProfileStore } from "@/stores/profileStore";

export function resetAllStores(): void {
  // Artist-scoped caches (details, profile sections, jobs, booking forms, etc.)
  clearArtistSessionCaches();

  // Contact details (primary/secondary)
  useContactDetailsStore.getState().reset();

  // Instagram connection/media/stats and OAuth state
  void useInstagramStore.getState().clearInstagramData();

  // In-app notifications
  useNotificationStore.getState().clearNotifications();

  // Bookings list/selection in dashboard
  useBookingStore.getState().clearBookings();

  // Subscription / membership state
  useSubscriptionStore.getState().clearSubscription();

  // Profile summary store
  useProfileStore.getState().clearProfile();

  // Video visibility (signup hero, etc.)
  useVideoStore.getState().setShowVideo(false);

  // AI assistant chat + misuse state
  const assistant = useAssistantStore.getState();
  assistant.clearSession();
  assistant.clearMisuseState();

  // User preferences (theme/language/notification toggles) – optional reset on logout
  useUserStore.getState().resetPreferences();
}

